<template>
  <sl-side-panel v-model="visible" :title="title" :width="50">
    <Tabs :animated="false">
      <TabPane label="基础信息">
        <Form class="sm" ref="form" :model="form" :rules="rules" :label-width="100">
          <FormItem label="姓名" prop="name">
            <Input v-model="form.name"></Input>
          </FormItem>
          <FormItem label="类型" prop="userType">
            <sl-select v-model="form.userType" dict="$debtorType"></sl-select>
          </FormItem>
          <FormItem label="出生日期" prop="birthday">
            <DatePicker type="date" v-model="form.birthday" placement="bottom-start" placeholder="出生日期" style="width:100%"></DatePicker>
          </FormItem>
          <FormItem label="联系电话" prop="phone">
            <Input v-model="form.phone"></Input>
          </FormItem>
          <FormItem label="身份证号码" prop="idCardCode">
            <Input v-model="form.idCardCode" :disabled="!!this.id"></Input>
          </FormItem>
          <FormItem label="身份证地址" prop="homeAddress">
            <Input v-model="form.homeAddress"></Input>
          </FormItem>
          <FormItem label="家庭住址" prop="familyAddress">
            <Input v-model="form.familyAddress"></Input>
          </FormItem>
          <FormItem label="住房状况" prop="house">
            <sl-select v-model="form.house" dict="$housingSituation"></sl-select>
          </FormItem>
          <FormItem label="婚姻状况" prop="marriage">
            <sl-select v-model="form.marriage" dict="$maritalStatus" type="radio"></sl-select>
          </FormItem>
        </Form>

      </TabPane>
      <TabPane label="附件">
        <sl-annex :related="[21,22,23,24]" @on-update="handleUpdateAnnex" :data="annexes" :preview-url="downloadUrl" :action="action"></sl-annex>
      </TabPane>
    </Tabs>
    <div slot="footer">
      <Button @click="reset()">重置</Button>
      <Button :loading="loading" @click="handleSubmit('form')" type="primary">确定</Button>
    </div>
    <Spin size="large" fix v-if="loading"></Spin>
  </sl-side-panel>
</template>
<script>
import { phoneValidator , idNumberValidator} from '@/util/validator'

  export default {
    data() {
      return {
        loading: false,
        id: null,
        orderId:null,
        form:{
          userType:null,
          name:null,
          phone:null,
          idCardCode:null,
          marriage:null,
          homeAddress:null,
          familyAddress:null,
          house:null,
          birthday:null,
        },
        rules:{
          name: [{ required: true, message: '请输入姓名', trigger: 'blur,change' }],
          idCardCode: [{ required: true, validator:idNumberValidator(), trigger: 'blur,change' }],
          phone: [{ required: true, validator:phoneValidator('请输入联系电话','请输入有效的联系电话'), trigger: 'blur,change' }],
          homeAddress: [{ required: true, message: '请输入身份证地址', trigger: 'blur,change' }],
          familyAddress: [{ required: true, message: '请输入家庭住址', trigger: 'blur,change' }],
          birthday: [{ type:'date' , required: true, message: '请输入出生日期', trigger: 'change' }],
          marriage: [{ type:'number', required: true, message: '请选择婚姻状况', trigger: 'blur,change' }],
          userType: [{ type:'number', required: true, message: '请选择类型', trigger: 'change' }],
          house: [{ type:'number', required: true, message: '请选择住房状况', trigger: 'change' }],
          enterpriseId: [{ type:'number', required: true, message: '请选择关联企业', trigger: 'blur,change' }],
        },
        visible:false,
        annexes:[],
        updateAnnexes:[],
        enterprises:[]
      }
    },
    computed: {
      title() {
        return (this.id ? '编辑' : '新增') + '个人信息'
      },
      action(){
        return this.$request.personAnnexUploadUrl()
      },
      downloadUrl(){
        return this.$request.personAnnexUrl()
      }
    },
    created(){
      this.def = { ...this.form }

      this.$request.enterpriseFilter({enterpriseCode:''}).then( resp => {
        this.enterprises = (resp.data.list || []).map( i => ({value:i.id , label:i.name}))
      })
    },

    methods: {
      query() {
        if (this.id) {
          this.loading = true
          this.$request.orderPerson(this.id).then(resp => {
            if( !resp.code ){
              resp.data = this.$utils.conv(resp.data , {'birthday':'date'})
              this.$utils.fill( this.form , resp.data )
              this.annexes = (resp.data.annexs || []).map( ({id , fileType}) => ({id , fileType}))

              this.loading = false
            }
          })
        }
      },

      init(orderId, id ){
        this.reset()
        this.orderId = orderId
        this.id = id
        this.query()
        this.visible = true
      }, 

      reset(){
        this.$refs['form'].resetFields()
        this.$utils.fill( this.form , this.def )
        this.annexes = []
      },

      save(){
        let params = { 
          ...this.form ,
          orderId: this.orderId
        }

        if( this.id ){
          params['id'] = this.id
        }


        params['annexIds'] = this.updateAnnexes

        let exec = this.id ? this.$request.orderPersonUpdate : this.$request.orderPersonCreate
        
        exec(params).then(resp => {
          if (resp.code) {
            this.$Message.error({ content: resp.msg })
          } else {
            this.$Message.success('保存成功')
            this.$emit('on-update')
            this.visible = false
          }
          this.loading = false
        })

      },

      handleUpdateAnnex(annexes){
        this.updateAnnexes = annexes.filter( i => i.id ).map( i => i.id)
      },

      handleSubmit(name){
        this.$refs[name].validate((valid) => {
          if (valid) {
            this.save()
            this.$emit('on-update')
          } else {
            this.$Message.error('参数错误');
          }
        })
      },

      handleClose() {

      }
    }
  }

</script>